/**
 * iOS Safari Scroll Lock Utility
 * Prevents elastic scrolling and maintains scroll position on iOS
 */

class IOScrollLock {
  constructor() {
    this.scrollPosition = 0;
    this.isLocked = false;
    // Use feature detection (touch points) instead of deprecated UA/platform sniffing.
    // Modern iPads report as MacIntel, so we detect touch capability + maxTouchPoints.
    this.iosCheck = ('ontouchstart' in window || navigator.maxTouchPoints > 1) &&
      /Mac|iPad|iPhone|iPod/.test(navigator.userAgent);
  }

  lock() {
    if (this.isLocked) return;
    this.isLocked = true;

    // Save scroll position
    this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

    // Apply iOS-specific scroll lock
    if (this.iosCheck) {
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.scrollPosition}px`;
      document.body.style.width = '100%';
    }

    // Always add overflow hidden (works for non-iOS browsers)
    document.body.classList.add('overflow-hidden');

    // Prevent touchmove on iOS
    if (this.iosCheck) {
      document.documentElement.style.overscrollBehavior = 'none';
    }
  }

  unlock() {
    if (!this.isLocked) return;
    this.isLocked = false;

    // Remove overflow hidden
    document.body.classList.remove('overflow-hidden');

    // Restore iOS scroll position
    if (this.iosCheck) {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.documentElement.style.overscrollBehavior = '';

      // Restore scroll position
      window.scrollTo(0, this.scrollPosition);
    }
  }
}

// Create global instance
window.iosScrollLock = window.iosScrollLock || new IOScrollLock();
